export const fxgBaseApi = '/authorizations/v1/fxg';

export const routes = Object.freeze({
  home: '/home',
  myActions: '/my-actions',
  manageDigitalAssets: '/manage-digital-assets',
  manageContacts: '/manage-contacts',
  userDetails: '/user-details',
});

export const apiPaths = Object.freeze({
  user: `${fxgBaseApi}/user`,
});
